import React from 'react'
import UploadComp from '../../components/upload/Upload'

const Upload = () => {
  return (
    <UploadComp/>
  )
}

export default Upload